// extracted by mini-css-extract-plugin
export default {"layoutContainer":"Layout_layoutContainer__Za-TK","layoutBody":"Layout_layoutBody__NmeGr","icon":"Layout_icon__pW5EK","layoutPara":"Layout_layoutPara__eZ35Y"};